import { useReportingStore } from "../../../../../stores/ReportingStore";
import LoaderStats from "../../LoaderStats";
import { Group, Paper, RingProgress, Text } from "@mantine/core";
import { BarChart } from "@mantine/charts";
import { useMemo } from "react";
import ReportingInfo from "../../ReportingInfo";
import { useLanguage } from "../../../../../stores/LanguageStore";

const PerfDelivrability = () => {
  const lang = useLanguage((s) => s.language);
  const statistics = useReportingStore((s) => s.actualStats);

  const sent = statistics.email_sent;
  const delivered = statistics.email_sent - statistics.contact_email_bounce;

  const averageRate = useMemo(() => {
    if (sent) {
      return (delivered / sent) * 100;
    }
    return 0;
  }, [delivered, sent]);

  return (
    <Paper pos={"relative"} flex={1} p={"xl"} pt={"md"}>
      <LoaderStats />

      <Group mb={32} justify="center">
        <Text size="lg" fw={600}>
          {lang.reports.perf_del_title}
        </Text>
      </Group>

      <BarChart
        h={200}
        w={"100%"}
        data={[
          {
            type: `${lang.reports.sent} / ${lang.reports.delivered}`,
            sent: sent,
            delivered: delivered,
          },
        ]}
        dataKey="type"
        series={[
          { name: "sent", label: lang.reports.sent, color: "blue.6" },
          {
            name: "delivered",
            label: lang.reports.delivered,
            color: "green.6",
          },
        ]}
        tickLine="y"
        maxBarWidth={64}
        yAxisLabel="Volume"
        barProps={{
          isAnimationActive: true,
          animationDuration: 600,
          radius: [8, 8, 0, 0],
        }}
      />

      <Group mt={16} justify="space-between">
        <Group justify="end" wrap="nowrap" ml={"auto"}>
          <ReportingInfo>
            <Text>{lang.reports.perf_del_average}</Text>
          </ReportingInfo>
          <Text size="lg">{lang.reports.perf_del_average_text}</Text>
          <RingProgress
            label={
              <Group justify="center" ml={16} mt={-8}>
                <Text size="lg" fw={600} ta="center">
                  {averageRate.toFixed(1)}%
                </Text>
              </Group>
            }
            roundCaps={averageRate < 92}
            sections={[{ value: averageRate, color: "green" }]}
          />
        </Group>
      </Group>
    </Paper>
  );
};

export default PerfDelivrability;
